import React from "react";

/**
 * SERP — Shanvi Enterprise Resource Planning brand primitives.
 * All variants are HD PNGs with transparent backgrounds served from /public.
 */

const FULL_LOGO_URL = "/serp-mark.png";
const ICON_URL = "/serp-icon.png";

/** Full brand lockup (mark + SERP wordmark). HD PNG, transparent background. */
export function SerpBrandLogo({ height = 40, className = "", testid = "serp-brand-logo" }) {
  return (
    <img
      src={FULL_LOGO_URL}
      alt="SERP — Shanvi Enterprise Resource Planning"
      style={{ height, width: "auto", display: "block" }}
      className={className}
      data-testid={testid}
      loading="eager"
      decoding="async"
    />
  );
}

/** Compact hexagonal S mark (no wordmark). Use for sidebars, top-bars, chips. */
export function SerpMark({ size = 32, className = "", testid = "serp-mark" }) {
  return (
    <img
      src={ICON_URL}
      alt="SERP"
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        display: "block",
      }}
      className={className}
      data-testid={testid}
      loading="eager"
      decoding="async"
    />
  );
}

/** Text wordmark. Single-tone Carbon gray-100 for enterprise clarity. */
export function SerpWordmark({ className = "", testid = "serp-wordmark" }) {
  return (
    <span
      className={`font-heading font-bold tracking-tight leading-none ${className}`}
      style={{ color: "#1A202C" }}
      data-testid={testid}
      aria-label="SERP"
    >
      SERP
    </span>
  );
}

export default SerpBrandLogo;
